import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import TigerGame from "@/components/game/TigerGame";

export default function GamePage() {
  return (
    <div className="min-h-screen paper" data-testid="game-page">
      <header className="sticky top-0 z-30 border-b-[3px] border-tiger-deep bg-tiger-sand/95 backdrop-blur-md">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-6">
          <Link
            to="/"
            className="inline-flex items-center gap-2 rounded-full border-[3px] border-tiger-deep bg-white px-4 py-2 font-heading text-base font-bold text-tiger-deep shadow-sticker hover:-translate-y-0.5 hover:shadow-stickerLg transition-transform"
            data-testid="back-to-home"
          >
            <ArrowLeft className="h-4 w-4" /> Back
          </Link>
          <p className="hidden sm:block font-heading text-xl font-bold text-tiger-deep">
            🐯 Tiger Adventure
          </p>
          <div className="rounded-full border-[3px] border-tiger-deep bg-tiger-orange px-4 py-1.5 font-heading text-sm font-bold text-white shadow-sticker">
            10 Levels
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-6xl px-4 py-8 sm:px-6 sm:py-12">
        <h1 className="text-center font-heading text-4xl font-bold text-tiger-deep sm:text-5xl">
          Help the Tiger Escape!
        </h1>
        <p className="mx-auto mt-3 max-w-2xl text-center font-body text-base text-tiger-deep sm:text-lg">
          Run, jump, eat, drink, do backflips and ROAR to scare the hunters
          across <span className="font-extrabold">10 levels</span>! Finish each
          level to earn stars and a Tiger Hero certificate.
        </p>
        <div className="mt-8">
          <TigerGame />
        </div>
      </main>
    </div>
  );
}
